import { jsx as e } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { Input as f } from "../Input/Input.js";
const i = p(
  ({ inputMode: t = "numeric", ...o }, r) => /* @__PURE__ */ e(
    f,
    {
      ...o,
      type: "text",
      inputMode: t,
      pattern: "[0-9]*",
      autoCapitalize: "none",
      autoCorrect: "off",
      spellCheck: "false",
      ref: r
    }
  )
);
export {
  i as NumberInput
};
